import { observer } from 'mobx-react-lite'
import Button from '@mui/material/Button'
import TextField from '@mui/material/TextField'
import HelpOutlineOutlined from '@mui/icons-material/HelpOutlineOutlined'
import { themeConfig } from '@gap/shared/theme'
import FlexAlignRight from 'reusable/mui/utilities/FlexAlignRight'
import SkeletonLoader from 'reusable/mui/skeleton/SkeletonLoader'
import { useAdvisorIntegrationFYIStore } from './AdvisorIntegrationFYIStore'

/** The FYI key fields with their help link; the share dialog shows this form on its own. */
export const AdvisorIntegrationFYIConnectModalContent = observer(function AdvisorIntegrationFYIConnectModalContent() {
   const advisorIntegrationFYIStore = useAdvisorIntegrationFYIStore()

   return <>
      <FlexAlignRight>
         <Button variant="text" component="a" target="_blank" size="small" rel="noopener noreferrer" startIcon={<HelpOutlineOutlined fontSize='small' sx={{ color: themeConfig.primary['800'] }} />}
            href="https://help.thegaphq.com/portal/en/kb/articles/connecting-to-fyi-docs">
            Where do I find these?
         </Button>
      </FlexAlignRight>

      <SkeletonLoader loading={advisorIntegrationFYIStore.loader.isLoading} title='Connecting'>
         <AccessKeyField />
         <SecretKeyField />
      </SkeletonLoader>
   </>
})

const AccessKeyField = observer(function AccessKeyField() {
   const advisorIntegrationFYIStore = useAdvisorIntegrationFYIStore()

   return advisorIntegrationFYIStore.formHandler.accessId.bindInput(inputProps =>
      <TextField
         fullWidth
         autoFocus
         label="Access Key ID*"
         sx={{ mt: 2 }}
         {...inputProps}
      />
   )
})

const SecretKeyField = observer(function SecretKeyField() {
   const advisorIntegrationFYIStore = useAdvisorIntegrationFYIStore()

   return advisorIntegrationFYIStore.formHandler.accessSecret.bindInput(inputProps =>
      <TextField
         fullWidth
         type="password"
         autoComplete="off"
         label="Secret Key ID*"
         sx={{ mt: 2 }}
         {...inputProps}
      />
   )
})
